/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { eventEnumSchema } from "./eventEnumSchema.ts";
import { yookassaPaymentCallbackObjectRequestSchema } from "./yookassaPaymentCallbackObjectRequestSchema.ts";

export const yookassaPaymentCallbackRequestSchema = z.object({
	event: eventEnumSchema.describe(
		"* `payment.waiting_for_capture` - Ожидает оплаты\n* `payment.succeeded` - Успешно завершен\n* `payment.canceled` - Отменен\n* `refund.succeeded` - Успешный возврат",
	),
	object: yookassaPaymentCallbackObjectRequestSchema,
});
